import React from 'react';
import { Stack, Text, ControlLink } from '@moda/om';
import WarningIcon from '@moda/icons/warning-20';

export const AccountLocked: React.FC = () => (
  <Stack direction="horizontal" space={1} alignItems="flex-start">
    <Text color="code-red">
      <WarningIcon />
    </Text>
    <Text color="ink">
      Account disabled after too many failed login attempts. Click{' '}
      <Text treatment="bold1">“Forgot Password”</Text> to reset your account or{' '}
      <ControlLink href="mailto:care@modaoperandi.com">Contact Support</ControlLink>.
    </Text>
  </Stack>
);
